export default {
    button: {
      size: {
        regular: 'px-4 py-2 text-sm',
        block: 'px-4 py-2 text-sm'
      },
    },
    input: {
        size: {
            regular: 'px-4 py-2 text-sm '
        }
    },
    alert: {
      base: 'p-4 pl-12 relative rounded-md leading-5',
    },
    textarea: {
      base: 'block w-full text-sm dark:text-gray-300 rounded-md focus:outline-none',
      active:
        'focus:border-blue-400 border-gray-300 dark:border-gray-600 dark:focus:border-gray-600 dark:bg-gray-700 dark:focus:ring-gray-300 focus:ring focus:ring-blue-300',
      disabled: 'cursor-not-allowed opacity-50 bg-gray-300 dark:bg-gray-800',
      valid:
        'border-green-600 dark:bg-gray-700 focus:border-green-400 dark:focus:border-green-400 focus:ring focus:ring-green-200 dark:focus:ring-green-200',
      invalid:
        'border-red-600 dark:bg-gray-700 focus:border-red-400 dark:focus:border-red-400 focus:ring focus:ring-red-200 dark:focus:ring-red-200',
    },
    // Select
    select: {
      base: 'block w-full text-sm dark:text-gray-300 focus:outline-none rounded-md',
      active:
        'focus:border-blue-400 border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:ring focus:ring-blue-300 dark:focus:ring-gray-300 dark:focus:border-gray-600',
      select: 'leading-5',
      disabled: 'cursor-not-allowed opacity-50 bg-gray-300 dark:bg-gray-800',
      valid:
        'border-green-600 dark:bg-gray-700 focus:border-green-400 dark:focus:border-green-400 focus:ring focus:ring-green-200 dark:focus:ring-green-200',
      invalid:
        'border-red-600 dark:bg-gray-700 focus:border-red-400 dark:focus:border-red-400 focus:ring focus:ring-red-200 dark:focus:ring-red-200',
    },
    // Label
    label: {
      base: 'block text-sm text-gray-700 dark:text-gray-400',
      // check and radio get this same style
      check: 'inline-flex items-center',
      disabled: 'opacity-50 cursor-not-allowed',
    },
    // Input
    input: {
      base: 'block w-full text-sm focus:outline-none dark:text-gray-300 leading-5 rounded-none',
      active:
        'focus:border-blue-400 border-gray-300 dark:border-gray-600 focus:ring focus:ring-blue-300 dark:focus:border-gray-600 dark:focus:ring-gray-300 dark:bg-gray-700',
      disabled: 'cursor-not-allowed opacity-50 bg-gray-300 dark:bg-gray-800',
      valid:
        'border-green-600 dark:bg-gray-700 focus:border-green-400 dark:focus:border-green-400 focus:ring focus:ring-green-200 dark:focus:ring-green-200',
      invalid:
        'border-red-600 dark:bg-gray-700 focus:border-red-400 dark:focus:border-red-400 focus:ring focus:ring-red-200 dark:focus:ring-red-200',
      radio:
        'text-blue-600 form-radio focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-offset-0 dark:focus:ring-gray-300',
      checkbox:
        'text-blue-600 form-checkbox focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-offset-0 rounded dark:focus:ring-gray-300',
    },
    // HelperText
    helperText: {
      base: 'text-xs',
      valid: 'text-green-600 dark:text-green-400',
      invalid: 'text-red-600 dark:text-red-400',
    },
    // Card
    card: {
      base: 'min-w-0 rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden',
      default: 'bg-white dark:bg-gray-800',
    },
    cardBody: {
      base: 'p-4',
    },
    // Button
    button: {
      base:
        'align-bottom inline-flex items-center justify-center cursor-pointer leading-5 transition-colors duration-150 font-medium focus:outline-none',
      block: 'w-full',
      size: {
        larger: 'px-10 py-4 rounded-none',
        large: 'px-5 py-3 rounded-none',
        regular: 'px-4 py-2 rounded-none text-sm',
        small: 'px-3 py-1 rounded-none text-sm',
        icon: {
          larger: 'p-4 rounded-lg',
          large: 'p-3 rounded-lg',
          regular: 'p-2 rounded-lg',
          small: 'p-2 rounded-md',
        },
        pagination: 'px-3 py-1 rounded-md text-xs',
      },
      // styles applied to the SVG icon
      icon: {
        larger: 'h-5 w-5',
        large: 'h-5 w-5',
        regular: 'h-5 w-5',
        small: 'h-3 w-3',
        left: 'mr-2 -ml-1',
        right: 'ml-2 -mr-1',
      },
      primary: {
        base: 'text-white bg-blue-600 border border-transparent',
        active: 'active:bg-blue-600 hover:bg-blue-700 focus:ring focus:ring-blue-300',
        disabled: 'opacity-50 cursor-not-allowed',
      }
    }
}